import { Calculator, MapPin, Mail, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A2421] text-[#D8D3C8] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-[#4A5D23] text-white">
                <Calculator className="h-5 w-5" />
              </span>
              <span className="font-heading font-bold text-xl text-white">
                Simply Balanced Bookkeeping
              </span>
            </div>
            <p className="text-base leading-relaxed text-[#A8A89E] max-w-sm">
              Friendly, reliable bookkeeping for businesses.
              Based in North Canton, Ohio. Clean books, clear numbers, and
              more time for what you love.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-semibold text-white mb-5">
              Explore
            </h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: "Services", href: "#services" },
                { label: "About", href: "#about" },
                { label: "Why Us", href: "#why" },
                { label: "Contact", href: "#contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-[#A8A89E] hover:text-[#E27A5E] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-white mb-5">
              Get in touch
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#E27A5E] shrink-0 mt-0.5" />
                <span>Based in North Canton, Ohio</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#E27A5E] shrink-0" />
                <a
                  href="tel:+13304516665"
                  data-testid="footer-phone"
                  className="hover:text-white transition-colors"
                >
                  (330) 451-6665
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#E27A5E] shrink-0" />
                <a
                  href="mailto:hello@simplybalancedbyjulie.com"
                  data-testid="footer-email"
                  className="hover:text-white transition-colors"
                >
                  hello@simplybalancedbyjulie.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8A8A80]">
          <p>
            © {new Date().getFullYear()} Simply Balanced Bookkeeping. All rights
            reserved.
          </p>
          <p>Bookkeeping services, based in North Canton, Ohio.</p>
        </div>
      </div>
    </footer>
  );
};
